export enum WidgetTemplateName {
  Basic = 'basic',
  VisualPerformance = 'visual-performance',
  Performance = 'performance',
  Visual = 'visual',
  Report = 'report',
  RapNet = 'rapnet',
  Video = 'video',
  Story = 'story',
}
